import { render, staticRenderFns } from "./userPointLog_list.vue?vue&type=template&id=bdfbd8ee&scoped=true"
import script from "./userPointLog_list.vue?vue&type=script&lang=js"
export * from "./userPointLog_list.vue?vue&type=script&lang=js"
import style0 from "./userPointLog_list.vue?vue&type=style&index=0&id=bdfbd8ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfbd8ee",
  null
  
)

export default component.exports